import React from 'react';
import '../Features/FeatureCard.css';
import rightplay from '../../assets/images/rightplay.png';

const FeatureCard = ({ image, header, descr }) => {
  const featuresOne = [
    "The School is affiliated to ICSE upto Class-XII with all the stream:- Science, Commerce & Humanities.",
    "Eco Friendly Campus.",
    "Digital classroom/Interactive board.",
    "Quality Education blended with values and ethics.",
    "Well equipped lab.",
    "Transport available on all routes.",
    "Scholarship for the meritorious students.",
    "Highly qualified and dedicated faculties.",
    "Interactive sessions with eminent personalities.",
    "Extra curricular activities [Yoga, Music, Art and craft, Taikandoo].",
    "Parents and Teacher meeting are conducted on regular bases for monitoring the growth of student’s performance.",
    "R.O. Water facility, Generator backup, fire safety precautions, fully secured campus.",
    "The learning in the Kindergarten are through Audio-visual ads, learning by doing, activities based.",
    "Interactive learning through TEACHMINT platform, where lectures are live and recorded.",
    "Outdoor activities are a part of our curriculum (Excursion, Nature walk, visit to Historical Places) etc."
  ];

  const featuresTwo = [
    "Co-Curricular Activities.",
    "Educational Tours.",
    "An annual magazine.",
    "Environmental Awareness Programmes.",
    "Annual Day Celebrations.",
    "Organised various Sports Tournament.",
    "Incentive & Scholarship Programs.",
    "Special coaching for competitive entrance exams.",
    "Students Social Gathering.",
    "Skills Development Programs."
  ];

  const listItems = descr === "ONE" ? featuresOne : featuresTwo;

  return (
    <div className="feature-card shadow-sm d-flex flex-column">
      <img src={image} className="feature-img img-fluid" alt={header} />
      <div className="card-body flex-grow-1 d-flex flex-column">
        <h3 className="card-title text-center">{header}</h3>
        <div className="list-group mt-3 flex-grow-1">
          {listItems.map((text, idx) => (
            <div className="d-flex align-items-start feature-row" key={idx}>
              <img src={rightplay} alt="" className="me-2 icon-img" />
              <p className="mb-0">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
